export const removeProperty = (
  propertyKey,
  { [propertyKey]: propertyValue, ...rest },
) => rest;

export const removeProperties = (object, ...keys) =>
  keys.length
    ? removeProperties(removeProperty(keys.pop(), object), ...keys)
    : object;
